import { render, staticRenderFns } from "./JawabPertanyaan.vue?vue&type=template&id=46c6a916&"
import script from "./JawabPertanyaan.vue?vue&type=script&lang=js&"
export * from "./JawabPertanyaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports